import Vue from 'vue'
import Router from 'vue-router'
import identity from './identity'

Vue.use(Router)

let pages = {
  "/users": () => import("views/users"),
  "/users/create": () => import("views/users/create"),
  "/users/edit/:id": () => import("views/users/edit"),
  "/roles": () => import("views/roles"),
  "/groups": () => import("views/groups"),
  "/forms": () => import("views/forms"),
  "/forms/create": () => import("views/forms/create"),
  "/forms/edit/:id": () => import("views/forms/edit"),
  "/functions": () => import("views/functions"),
  "/layouts": () => import("views/layouts"),
  "/layouts/create": () => import("views/layouts/create"),
  "/layouts/edit/:id": () => import("views/layouts/edit"),
  "/contents": () => import("views/contents"),
  "/picklists": () => import("views/picklists"),
  "/announcement": () => import("views/announcement"),

  "/users/unregister": () => import("views/users/unregister"),
  "/county": () => import("views/parameter-settings/county"),
  "/county-add": () => import("views/parameter-settings/county-add"),
  "/county-edit/:id": () => import("views/parameter-settings/county-edit"),
  "/town": () => import("views/parameter-settings/town"),
  "/town-add": () => import("views/parameter-settings/town-add"),
  "/town-edit/:id": () => import("views/parameter-settings/town-edit"),
  "/town-to-detect-station": () => import("views/parameter-settings/town-to-detect-station"),
  "/town-to-detect-station-edit/:id": () => import("views/parameter-settings/town-to-detect-station-edit"),
  "/mag": () => import("views/parameter-settings/mag"),
  "/detect-station": () => import("views/sources/detect-station"),
  "/detect-station-add": () => import("views/sources/detect-station-add"),
  "/detect-station-edit/:id": () => import("views/sources/detect-station-edit"),
  "/detect-station-detail/:id": () => import("views/sources/detect-station-detail"),
  "/news-source": () => import("views/sources/news-source"),
  "/news-source-add": () => import("views/sources/news-source-add"),
  "/news-source-edit/:id": () => import("views/sources/news-source-edit"),
  "/upstream": () => import("views/monitoring/upstream"),
  "/upstream-detail/:id": () => import("views/monitoring/upstream-detail"),
  //"/internal": () => import("views/monitoring/internal"),
  "/downstream": () => import("views/monitoring/downstream"),
  "/downstream-detail/:id": () => import("views/monitoring/downstream-detail"),
  "/cwb-detail/:id": () => import("views/monitoring/cwb-detail"),
  "/received": () => import("views/records/received"),
  "/published": () => import("views/records/published/"),
  "/published/advanced": () => import("views/records/published/vip"),
  "/event-report":()=>import("views/records/event-report/"),
  "/event-report/advanced":()=>import("views/records/event-report/vip"),
  "/scenario": () => import("views/exercises/scenario"),
  "/exercise-list": () => import("views/exercises/list"),
  "/forward": () => import("views/records/forward/"),
  "/forward/advanced": () => import("views/records/forward/vip"),
  "/user-action": () => import("views/user-action"),
  "/data-sync":()=>import("views/dataSync"),
};

let routes = [{
  path: "",
  component: () =>
    import("views/shared/layout"),
  children: [{
    name: "/",
    path: "/",
    component: () =>
      import("views/users/mqtt")
  },
  {
    name: "/selfEdit",
    path: "/selfEdit",
    meta: {
      noPermission: true
    },
    component: () =>
      import("views/users/selfEdit")
  },
  {
    name: "/mqtt",
    path: "/mqtt",
    meta: {
      noPermission: true
    },
    component: () =>
      import("views/users/mqtt")
  },
  ...Object.keys(pages).map(b => {
    return {
      name: b,
      path: b,
      component: pages[b]
    };
  })
  ]
}];

export default new Router({
  routes: [{
    path: '/login',
    component: () => import('views/login'),
    meta: {
      allowAnonymous: true
    }
  }, {
    path: '/forgetPassword',
    component: () => import('views/forgetPassword'),
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/confirmforget',
    component: () => import('views/confirmforget'),
    meta: {
      allowAnonymous: true,
    },
  }, 
  {
    path: '/changePassword',
    component: () => import('views/changePassword'),
    meta: {
      allowAnonymous: true,
    },
  },{
    path: '/register',
    component: () => import('views/register'),
    meta: {
      allowAnonymous: true
    }
  }, ...routes, {
    path: "",
    component: () => import("views/shared/layout"),
    children: [{
      name: '404',
      path: "*",
      component: () => import("views/404")
    }]
  }]
})

identity.authorize();



// WEBPACK FOOTER //
// ./src/router/index.js